import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiChevronDown } from "react-icons/fi";
import "./faq-section.scss";

export function FaqSection() {
  const { t } = useTranslation();
  const [openItem, setOpenItem] = useState<number | null>(null);

  const questions = [
    {
      question: t("faqQuestionCancellation"),
      answer: t("faqAnswerCancellation"),
    },
    {
      question: t("faqQuestionChangePlan"),
      answer: t("faqAnswerChangePlan"),
    },
    {
      question: t("faqQuestionPaymentMethods"),
      answer: t("faqAnswerPaymentMethods"),
    },
    {
      question: t("faqQuestionDiscount"),
      answer: t("faqAnswerDiscount"),
    },
  ];

  return (
    <section className="faq-section">
      <div className="faq-section-card">
        <header className="faq-section-header">
          <h2>{t("faqSectionTitle")}</h2>
        </header>

        <div className="faq-section-list">
          {questions.map((item, index) => {
            const isOpen = openItem === index;
            const answerId = `faq-section-answer-${index}`;

            return (
              <div className="faq-section-item" key={item.question}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => setOpenItem(isOpen ? null : index)}
                >
                  <span>{item.question}</span>
                  <FiChevronDown
                    className={isOpen ? "faq-section-icon-open" : ""}
                    aria-hidden="true"
                  />
                </button>

                <div
                  id={answerId}
                  className={`faq-section-answer ${
                    isOpen ? "faq-section-answer-open" : ""
                  }`}
                >
                  <p>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
